export default (resultCallback) => (progressEvent) => {
  const percentFraction = progressEvent.loaded / progressEvent.total;
  const progress = Math.floor(percentFraction * 100);
  resultCallback(progress);
};
